import React from 'react';
import styled, { css } from 'styled-components';

import { convertThumbnailToPictureImage } from '@tager/web-modules';

import Picture from '@/components/Picture';
import Link from '@/components/Link';
import { media } from '@/utils/mixin';

import { DetailedCarBannerProps } from './types';

function DetailedCarBanner({
  image,
  imageMobile,
  url,
  isNewTab,
}: DetailedCarBannerProps) {
  return (
    <Component to={url} target={isNewTab ? '_blank' : '_self'}>
      <Image
        loading="lazy"
        desktop={convertThumbnailToPictureImage(image)}
        laptop={convertThumbnailToPictureImage(image)}
        tabletSmall={convertThumbnailToPictureImage(image)}
        mobile={convertThumbnailToPictureImage(imageMobile ?? image)}
      />
    </Component>
  );
}

export default DetailedCarBanner;

const Component = styled(Link)``;

const Image = styled(Picture)`
  padding-top: 23.959%;

  ${media.tablet(css`
    padding-top: 20.715%;
  `)}

  picture,
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  img {
    object-fit: cover;
  }
`;
